/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QuotesService {
    /**
     * Refresh Quote
     * @param serviceRequestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshQuoteQuotesServiceRequestIdRefreshPost(
        serviceRequestId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/quotes/{service_request_id}/refresh',
            path: {
                'service_request_id': serviceRequestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Quote
     * @param serviceRequestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getQuoteQuotesServiceRequestIdGet(
        serviceRequestId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/quotes/{service_request_id}',
            path: {
                'service_request_id': serviceRequestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
